import { IBlockData } from '../../../typings';
import { BasicType } from '../../../constants';
import React, { CSSProperties } from 'react';
import { merge } from 'lodash';
import { BasicBlock } from '../../../components/BasicBlock';
import { createBlock, t } from '../../../utils';

export type IWrapper = IBlockData<
    {
        'background-color'?: string;
        border?: string;
        'border-radius'?: string;
        'full-width'?: string;
        direction?: 'ltr' | 'rtl';
        padding?: string;
        'text-align'?: CSSProperties['textAlign'];
    },
    {}
>;

export const Wrapper = createBlock<IWrapper>({
    get name() {
        return t('Wrapper');
    },
    type: BasicType.WRAPPER,
    create: (payload: any) => {
        const defaultData: IWrapper = {
            type: BasicType.WRAPPER,
            data: {
                value: {},
            },
            attributes: {
                padding: '20px 0px 20px 0px',
                border: 'none',
                direction: 'ltr',
                'text-align': 'center',
            },
            children: [],
        };
        return merge(defaultData, payload);
    },
    validParentType: [BasicType.PAGE],
    render(params: any) {
        return <BasicBlock params={params} tag="mj-wrapper" />;
    },
});
